// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InitialDataAPIModel,
    InitialDataAPIModelFromJSON,
    InitialDataAPIModelToJSON,
} from '../models';

/**
 * BffApi - interface
 * 
 * @export
 * @interface BffApiInterface
 */
export interface BffApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BffApiInterface
     */
    bffControllerInitRaw(): Promise<runtime.ApiResponse<InitialDataAPIModel>>;

    /**
     */
    bffControllerInit(): Promise<InitialDataAPIModel>;

}

/**
 * 
 */
export class BffApi extends runtime.BaseAPI implements BffApiInterface {

    /**
     */
    async bffControllerInitRaw(): Promise<runtime.ApiResponse<InitialDataAPIModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bff/init`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InitialDataAPIModelFromJSON(jsonValue));
    }

    /**
     */
    async bffControllerInit(): Promise<InitialDataAPIModel> {
        const response = await this.bffControllerInitRaw();
        return await response.value();
    }

}
